module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_8003.69f880fc.png";